import { render } from "./CopyAiPromptButton.vue?vue&type=template&id=57962191&scoped=true"
import script from "./CopyAiPromptButton.vue?vue&type=script&lang=js"
export * from "./CopyAiPromptButton.vue?vue&type=script&lang=js"

import "./CopyAiPromptButton.vue?vue&type=style&index=0&id=57962191&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57962191"]])

export default __exports__